import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import junior from 'assets/images/junior.jpg'
import piacievski from 'assets/images/piacievski.jpg'
import petrassi from 'assets/images/petrassi.jpg'
import teixeira from 'assets/images/teixeira.jpg'
import Header from 'components/Header'
import Footer from 'components/Footer'

const LawyerDetails = () => {
  const { oab } = useParams()

  const data = [
    {
      name: 'Dr. José Macias Nogueira Junior',
      specialization: 'Direito Empresarial',
      email: 'jrmaciasjr@gmail.com',
      phone: '(00) 0000-0000',
      image: junior,
      oab: 'PR123456',
    },
    {
      name: 'Dr. Diego Pulzatto Piacievski',
      specialization: 'Direito Civil e Penal',
      email: 'escritoriopiacievski@gmail.com',
      phone: '(00) 0000-0000',
      image: piacievski,
      oab: 'PR567890',
    },
    {
      name: 'Dra. Renata Lima Petrassi',
      specialization: 'Recuperação de Crédito',
      email: 'renataft_advogada@hotmail.com',
      phone: '(00) 0000-0000',
      image: petrassi,
      oab: 'PR654321',
    },
    {
      name: 'Dra. Renata Fontes Pereira Teixeira',
      specialization: 'Direito de Família e Civil',
      email: 'exemplo@gmail.com',
      phone: '(00) 0000-0000',
      image: teixeira,
      oab: 'PR987654',
    },
  ]

  const lawyer = data.find((lawyer) => lawyer.oab === oab)

  if (!lawyer) {
    return <div>Advogado não encontrado.</div>
  }

  useEffect(() => {
    document.title = `Macias & Cruz - ${lawyer.name}`
    window.scrollTo(0, 0)
  }, [oab])

  return (
    <main className='flex w-full flex-col items-center justify-center py-6'>
      <Header />
      <div className='my-20 flex w-11/12 flex-col items-center justify-center gap-4 md:w-9/12 md:flex-row md:gap-8'>
        <img src={lawyer.image} alt={lawyer.name} className='w-full md:w-1/4' />
        <div className='flex w-full flex-col gap-4 md:w-1/2'>
          <h1 className='text-2xl font-bold md:text-5xl'>{lawyer.name}</h1>
          <p className='text-gray-700 text-justify text-base md:text-xl'>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. A repudiandae nulla magni fuga suscipit laboriosam!
            Culpa, porro nobis voluptas saepe, facilis ex nostrum animi, magni eum ab sit? Suscipit, autem optio facilis
            delectus similique eveniet sunt nulla aut ut excepturi corrupti officia libero eius ab magni impedit
            repellendus! Harum, rem?
          </p>
          <div className='flex flex-col gap-2'>
            <p className='text-gray-600 text-lg'>E-mail: {lawyer.email}</p>
            <p className='text-gray-600 text-lg'>Telefone: {lawyer.phone}</p>
            <p className='text-gray-600 text-lg'>OAB: {lawyer.oab}</p>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default LawyerDetails
